import React, { FC, useEffect, useRef, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { initReactI18next, useTranslation } from "react-i18next";

const InitializePw = ({ dispatch_post_password_reset }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const ref = useRef();
  const [t, i18n] = useTranslation();

  const [password, set_password] = useState("");
  const [passwordConfirm, set_passwordConfirm] = useState("");

  useEffect(() => {}, []);
  return (
    <div class="d-flex flex-column justify-content-between bg-light vh-100">
      <header className="py-3 mb-auto bg-brand">
        <div className="container d-flex justify-content-center align-items-center">
          <a
            href="index.html"
            onClick={(e) => {
              e.preventDefault();
              history.push({
                pathname: `/top`,
              });
              window.scroll(0, 0);
            }}
          >
            <img src="images/brand-white.svg" height={28} alt="SC WORLD EXCHANGE" />
          </a>
        </div>
      </header>
      <main role="main" className="main">
        <div className="container">
          <section className="login-section mx-auto mb-4">
            <div className="card">
              <div className="card-body">
                <form action="initialize-pw-success.html" method="post">
                  <h1 className="h4 text-center font-weight-bold mb-4">
                    {t("パスワードの再設定")}
                  </h1>
                  <div className="form-group">
                    <label htmlFor="npw"> {t("新しいパスワード")}</label>
                    <input
                      type="password"
                      id="npw"
                      className="form-control"
                      placeholder={t("新しいパスワード")}
                      required
                      // autofocus
                      value={password}
                      onChange={(e) => {
                        set_password(e.target.value);
                      }}
                    />
                    <small className="form-text">
                      {t(
                        "大文字小文字数字混在の１０文字以上で入力してください。"
                      )}
                    </small>
                  </div>
                  <div className="form-group">
                    <label htmlFor="npwc">{t("新しいパスワード(確認用)")}</label>
                    <input
                      type="password"
                      id="npwc"
                      className="form-control"
                      placeholder={t("新しいパスワード(確認用)")}
                      required
                      value={passwordConfirm}
                      onChange={(e) => {
                        set_passwordConfirm(e.target.value);
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <button
                      className="btn btn-gradient-primary btn-block"
                      onClick={(e) => {
                        e.preventDefault();
                        dispatch_post_password_reset({ password }, () => {
                          history.push({
                            pathname: `/signin`,
                          });
                          window.scroll(0, 0);
                        });
                      }}
                    >
                     {t("パスワードの再設定")}
                      
                    </button>
                  </div>
                  <hr />
                  <a
                    className="btn btn-link btn-block"
                    href="signin.html"
                    onClick={(e) => {
                      e.preventDefault();
                      history.push({
                        pathname: `/signin`,
                      });
                      window.scroll(0, 0);
                    }}
                  >
                    <i className="fas fa-home" />
                     {t("トップページ")}
                  </a>
                </form>
              </div>
            </div>
          </section>
        </div>
      </main>
      <footer className="mt-auto" />
    </div>
  );
};

export default InitializePw;
